<div id="editenduser" class="subBlockContainer">
    <div class="subBlockContent">
        <child-header (click)="close()"></child-header>
        <div class="inner-subBlock-wrapper">
            <div class="container">
                <div class="row">
                    <!-- <div class="userinfo col-md-6" *ngIf="companyCode==='T01' || companyCode==='1'"> -->
                        <div class="userinfo col-md-6">
                        <div class="payment-title">Payment Method</div>
                        <div id="list-payment">
                            <div class="noData-wrapper" *ngIf="!paymentList?.length">
                                <div>
                                    <img src="../images/new_ui/no-wallet.png">
                                </div>
                                <div class="noData-label">Your digital wallet is empty.</div>
                                <div class="button-center">
                                    <button id="addPaymentBtn" class="button button-red button-large"
                                            (click)="navigateToDigitalWallet()"
                                            [disabled]="!(user$|async)?.hasAdminAccess && !(user$|async)?.hasPurchaseAccess"
                                            [matTooltipDisabled]="(user$|async)?.hasAdminAccess || (user$|async)?.hasPurchaseAccess"	
                                             matTooltip="Requires Purchasing Permissions"
                                    >Create new</button>
                                </div>
                            </div>

                            <ng-container *ngIf="paymentList?.length">
                                <div class="row margin-top-30">
                                    <div class="col-sm">
                                        <label class="po-label">Select a payment from your wallet</label><br />
                                        <button class="button button-red button-mid reset-payment" [disabled]="!editable" (click)="resetPayment()">Reset Payment
                      Option</button>
                                        <mat-form-field>
                                            <mat-select [(value)]="selectedPayment" [disabled]="!editable" (selectionChange)="selectPaymentMethod();">
                                                <mat-option value="{{payment.value}}" *ngFor="let payment of paymentList">{{payment.text}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <ng-container *ngIf="hasEmptyFilterResult">
                                    <div class="noData-wrapper">
                                        <div><img src="../images/new_ui/no-wallet.png"></div>
                                        <div class="noData-label">Your digital wallet is empty.</div>
                                        <div class="button-center">
                                            <button class="button button-red button-large" (click)="navigateToDigitalWallet()"
                                                    [disabled]="!(user$|async)?.hasAdminAccess && !(user$|async)?.hasPurchaseAccess"
                                                    [matTooltipDisabled]="(user$|async)?.hasAdminAccess || (user$|async)?.hasPurchaseAccess"	
                                                    matTooltip="Requires Purchasing Permissions"
                                            >Create now</button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>

                </div>
                <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="984" (currentLoadingStatus)="onLoading($event)"></loading-screen>
            </div>
        </div>
    </div>
</div>